import { MS_IN_DAY } from '../../utils/time-utils';
import type { EntryPointPayload, EntryPointPayloadRecord } from './types';

const ENTRY_POINT_EXPIRATION_DAYS = 31;
const ENTRY_POINT_EXPIRY_TIMESTAMP = Date.now() - MS_IN_DAY * ENTRY_POINT_EXPIRATION_DAYS;

export function isEntryPointPayloadExpired(payload: EntryPointPayload | EntryPointPayloadRecord): boolean {
  return payload.timestamp < ENTRY_POINT_EXPIRY_TIMESTAMP;
}
